import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createService, updateService } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveService(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateService(id, { serviceProviderId, ...data }),
    createFn: async () => createService({ serviceProviderId, ...data })
  });
}

export default function* saveServiceSaga() {
  yield takeLatest(AT.SAVE_SERVICE_SAGA, processSaveService);
}
